<template>
  <div class="b-booking-progress">
    <div class="b-booking-progress__desktop">
      <div class="b-booking-progress__wrapper">
        <div class="b-booking-progress__selected-movie">
          <div class="b-canteen-progress-bar__cinema-details"></div>
          <div class="b-booking-progress__actions">
            <button
              type="button"
              class="b-booking-progress__actions__cta__prev"
              @click="goToPreviousStep">
              <span>{{ dictionary.buttonPreviousPaymentText }}</span>
            </button>
            <button
              type="button"
              class="b-booking-progress__actions__cta__next btn-primary-orange"
              :disabled="isValid"
              @click="goToNextStep">
              <span>{{ dictionary.buttonNextPaymentText }}</span>
            </button>
          </div>
          <!-- progress bar -->
          <div
            class="b-booking-progress__progress-bar"
            :style="progressStyle"></div>
        </div>
      </div>
    </div>
    <div class="b-booking-progress__mobile">
      <div class="b-booking-progress__wrapper--canteen">
        <div
          v-if="currentStep === 1"
          class="b-booking-progress__wrapper--canteen__price">
          {{ roundToDigits(totalCartAmount) }} €
        </div>
        <button
          type="button"
          class="btn-primary-orange"
          :class="{ 'btn--block': currentStep === 2 }"
          :disabled="isValid"
          @click="goToNextStep">
          <span>{{ dictionary.buttonNextPaymentText }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useBookingStore } from '../store/BookingStore'

export default {
  props: {
    currentStep: { default: 1, type: Number },
    isValid: { default: false, type: Boolean },
  },
  emits: ['go-to-previous', 'go-to-next'],
  setup() {
    return { store: useBookingStore() }
  },
  computed: {
    progressStyle() {
      return `--progress: ${this.currentStep * 85}`
    },

    totalCartAmount() {
      return this.store.getTotalSelectedProducts
    },
  },
  methods: {
    goToPreviousStep() {
      this.$emit('go-to-previous')
    },
    goToNextStep() {
      this.$emit('go-to-next')
    },

    roundToDigits(price) {
      return (
        price &&
        parseFloat(price).toLocaleString(document.documentElement.lang, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      )
    },
  },
}
</script>
